export const DrawerMainLayoutOpen = () => ({
    type: 'DrawerMainLayoutOpen'
});

export const DrawerMainLayoutClose = () => ({
    type: 'DrawerMainLayoutClose'
});
